import CustomAmplitudeClient from "./custom-amplitude-client.b75422c9d833.js";
import { CareQuality } from "./care-quality.96ea997b6027.js";
import { PriceVerification } from "./price-verification.06b987f1a712.js";
import {
  InsuranceSelectorChangedEventType,
  OpenInsuranceSelectorEvent,
  bindHtmxInsuranceSwitching,
} from "./insurance-selector-events.382c4178547f.js";

class CostBreakdownPage {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);
    new PriceVerification();
    new CareQuality();

    this.elements = {
      printButton: document.getElementById("print-button"),
      accordions: document.querySelectorAll("details"),
      changeInsuranceButton: document.getElementById("change-insurance"),
      shareButton: document.getElementById("share-button"),
      costBreakdownInsuranceForm: document.getElementById(
        "cost-breakdown-insurance-picker",
      ),
    };
    this.bindPrintPreviewHandler();
    this.bindInputHandlers();
    this.bindShareButtonHandler();
    this.bindChangeInsuranceHandler();
    this.bindInsurancePickerEvents();
    this.bindContactProviderHandler();
    bindHtmxInsuranceSwitching();
    this.bindOpenInsuranceDialogHandler();
  }

  bindPrintPreviewHandler() {
    window.matchMedia("print").addEventListener("change", (e) => {
      // Open all the accordions when printing
      this.elements.accordions.forEach((accordion) => {
        if (e.matches) {
          accordion.setAttribute("open", e.matches);
        } else {
          accordion.removeAttribute("open");
        }
      });
    });
  }

  bindInputHandlers() {
    this.elements.printButton?.addEventListener("click", () => {
      window.print();
    });
  }

  bindContactProviderHandler() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest(".contact-provider");
      if (button) {
        this.amplitudeClient.trackStartContactProvider(button.dataset.location);
        const modal = document.querySelector("#contact-provider-modal");
        modal.showModal();
        modal.scrollIntoView();
      }
    });
  }

  bindShareButtonHandler() {
    this.elements.shareButton?.addEventListener("click", () => {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href,
        });
      }
    });
  }

  bindChangeInsuranceHandler() {
    this.elements.changeInsuranceButton?.addEventListener("click", (e) => {
      e.stopPropagation();
      document.dispatchEvent(
        new OpenInsuranceSelectorEvent(true, {
          navMethod: "summary-change-insurance",
        }),
      );
    });
  }

  // v1 path: form submission triggers full page reload
  bindInsurancePickerEvents() {
    this.elements.costBreakdownInsuranceForm?.addEventListener(
      InsuranceSelectorChangedEventType,
      () => {
        this.elements.costBreakdownInsuranceForm.submit();
      },
    );
  }

  bindOpenInsuranceDialogHandler() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest("[data-action='open-insurance-dialog']");
      if (button) {
        document.dispatchEvent(
          new OpenInsuranceSelectorEvent(false, {
            navMethod: "cost-summary-button",
          }),
        );
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CostBreakdownPage();
});
